import axios from 'axios';
import * as React from 'react';
import { requestDeleteApTemplateAction } from '../asyncHelpers/actionPlanTemplateService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncDeleteApTemplateAction
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestDeleteApTemplateAction HTTP request
 */
export default function useAsyncDeleteApTemplateAction() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncDeleteApTemplateAction = async (
        templateId: number,
        actionId: number,
    ): Promise<boolean | undefined> => {
        try {
            setRequestStatus(RequestStatus.active);

            await requestDeleteApTemplateAction(templateId, actionId, request_token.token);

            setRequestStatus(RequestStatus.success);

            return true;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while deleting template action');

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncDeleteApTemplateAction,
    };
}
